module.exports = __webpack_public_path__ + "media/SelectUI.b2339a33.wav";